module.exports = __webpack_public_path__ + "static/img/cont3106.a3725ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3106.jpg
// module id = AiR3
// module chunks = 0